import { premiumBuildingsPrices } from "@/config/constants";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class StonemasonryDistrictBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.STONEMASONRY_DISTRICT;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];
}

export default StonemasonryDistrictBuildingTileEntity;
